export default __webpack_public_path__ + "static/media/background.bc80df1b.png";